import { useTranslation } from 'react-i18next';
import { CardActionLink } from '@/common/components/CardActionLink/CardActionLink';
import { Icon } from '@/common/components/Icons/Icon';
import { ROUTES } from '@/common/constants/routes';

export type TBudgetsApplicationsCardProps = {
  hasBudgets: boolean;
};

export function BudgetsApplicationsCard({
  hasBudgets,
}: TBudgetsApplicationsCardProps) {
  const { t } = useTranslation();
  return (
    <CardActionLink
      icon={<Icon icon="star" />}
      iconBadgeColor="accentPrimary40"
      title={
        hasBudgets
          ? t('dashboard.budgets.apply_card.title')
          : t('dashboard.budgets.empty_card.title')
      }
      description={
        hasBudgets
          ? t('dashboard.budgets.apply_card.description')
          : t('dashboard.budgets.empty_card.description')
      }
      href={ROUTES.BUDGET_APPLICATIONS}
      size="md"
    />
  );
}
